import { useEffect } from 'react';
import { Icon } from './Icon';

export function Choices({ choices, selected, onSelect, onConfirm, disabled = false, label = '응답 선택' }: {
  choices: { id: string; text: string }[]; selected: string | null;
  onSelect: (id: string) => void; onConfirm: () => void; disabled?: boolean; label?: string;
}) {
  useEffect(() => {
    if (disabled) return;
    const key = (e: KeyboardEvent) => {
      if (e.repeat || e.isComposing || e.altKey || e.ctrlKey || e.metaKey || (e.target instanceof HTMLElement && e.target.matches('input, textarea, select'))) return;
      const idx = e.key === '1' || e.key === 'ArrowUp' ? 0 : e.key === '2' || e.key === 'ArrowDown' ? 1 : -1;
      const choice = choices[idx];
      if (choice) { e.preventDefault(); onSelect(choice.id); }
      else if (e.key === 'Enter' && selected && (!(e.target instanceof HTMLElement) || e.target.tagName !== 'BUTTON')) { e.preventDefault(); onConfirm(); }
    };
    window.addEventListener('keydown', key);
    return () => window.removeEventListener('keydown', key);
  }, [choices, selected, onSelect, onConfirm, disabled]);
  return <div className="choice-list" role="group" aria-label={label}>{choices.map((choice, index) =>
    <button type="button" key={choice.id} className={`choice ${selected === choice.id ? 'selected' : ''}`} aria-pressed={selected === choice.id} disabled={disabled} onClick={() => onSelect(choice.id)}
      onKeyDown={e => { if (e.key === 'Enter' && selected && !disabled) { e.preventDefault(); onConfirm(); } }}>
      <span className="choice-circle" /><span className="choice-number">{index + 1}</span><span>{choice.text}</span>
    </button>,
  )}</div>;
}
export function KeyHelp() { return <span className="key-help"><Icon name="keyboard" size={16} />숫자 1·2 또는 ↑↓로 선택 · Enter로 확인</span>; }
